// District-level beneficiary breakdown — mock data seeded for each state Lenovo CSR works in.
// District names match those in the India districts TopoJSON (shapeName property).

export const DISTRICT_REACH = {
  "Karnataka": [
    { district: "Bangalore",       beneficiaries: 1680 },
    { district: "Mysore",          beneficiaries: 1240 },
    { district: "Belgaum",         beneficiaries: 940 },
    { district: "Mangalore",       beneficiaries: 820 },
    { district: "Hubli-Dharwad",   beneficiaries: 640 },
    { district: "Tumakuru",        beneficiaries: 480 },
  ],
  "Maharashtra": [
    { district: "Pune",            beneficiaries: 1480 },
    { district: "Mumbai",          beneficiaries: 1320 },
    { district: "Nashik",          beneficiaries: 920 },
    { district: "Nagpur",          beneficiaries: 780 },
    { district: "Aurangabad",      beneficiaries: 700 },
  ],
  "Uttar Pradesh": [
    { district: "Lucknow",         beneficiaries: 1480 },
    { district: "Kanpur Nagar",    beneficiaries: 1180 },
    { district: "Varanasi",        beneficiaries: 940 },
  ],
  "Gujarat": [
    { district: "Ahmadabad",       beneficiaries: 1240 },
    { district: "Surat",           beneficiaries: 920 },
    { district: "Vadodara",        beneficiaries: 640 },
  ],
  "Tamil Nadu": [
    { district: "Chennai",         beneficiaries: 980 },
    { district: "Madurai",         beneficiaries: 760 },
    { district: "Coimbatore",      beneficiaries: 660 },
  ],
  "Telangana": [
    { district: "Hyderabad",       beneficiaries: 940 },
    { district: "Rangareddy",      beneficiaries: 660 },
  ],
  "Delhi": [
    { district: "New Delhi",       beneficiaries: 820 },
    { district: "South Delhi",     beneficiaries: 680 },
  ],
  "Kerala": [
    { district: "Idukki",          beneficiaries: 620 },
    { district: "Ernakulam",       beneficiaries: 480 },
    { district: "Thiruvananthapuram", beneficiaries: 300 },
  ],
  "Puducherry": [
    { district: "Puducherry",      beneficiaries: 1200 },
  ],
  "Jharkhand": [
    { district: "Ranchi",          beneficiaries: 640 },
    { district: "Dhanbad",         beneficiaries: 460 },
  ],
  "Assam": [
    { district: "Kamrup Metropolitan", beneficiaries: 560 },
    { district: "Dibrugarh",       beneficiaries: 390 },
  ],
  "Manipur": [
    { district: "Imphal West",     beneficiaries: 700 },
  ],
  "Meghalaya": [
    { district: "East Khasi Hills", beneficiaries: 650 },
  ],
  "Uttarakhand": [
    { district: "Dehradun",        beneficiaries: 360 },
    { district: "Nainital",        beneficiaries: 240 },
  ],
};
